import styled from '@emotion/styled'

export const RepeatTypeSelectWrapper = styled.div`
  min-width: 100px;
`
